var map = {
	"./alpint.jpg": 70,
	"./cykel.jpg": 2660,
	"./golf.jpg": 8592,
	"./hockey.jpg": 9442,
	"./längd.jpg": 1390,
	"./racketsport.jpg": 251,
	"./ridsport.jpg": 7501,
	"./skridskor.jpg": 7199,
	"./snowboard.jpg": 6100,
	"./soccer.jpg": 8721
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 424;